export enum ProgressbarSize {
  small = 'small',
  medium = 'medium',
  large = 'large',
}

export enum ProgressBarMode {
  ondark = 'ondark',
  onlight = 'onlight',
}

export enum Overlay {
  screen = 'screen',
  parent = 'parent',
}
